<template>
	<div>
		<p class="push-target-direct__desc">
			회원항번을 한줄에 1개씩 입력해주세요. (Enter 구분)
		</p>
		<textarea class="push-target-direct__id-box" @input="input"></textarea>
		<p class="push-target-direct__result">총 {{ getNum }}명</p>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="add">
				선택한 대상 추가
			</button>
			<button
				class="btn-main blue bordered"
				type="button"
				@click="cancel"
			>
				취소
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PushTargetDirect',
		data() {
			return {
				idRegisterList: [],
			};
		},
		computed: {
			getNum() {
				this.idRegisterList = this.idRegisterList.filter(v => !!v);
				return this.idRegisterList.length;
			},
		},
		methods: {
			parseToNumber(value) {
				return this.idRegisterList.map(id => {
					const matchedValue = id.match(/\d+/g);
					return Array.isArray(matchedValue)
						? matchedValue.join('')
						: '';
				});
			},
			input(e) {
				let newValue = e.target.value;
				this.idRegisterList = e.target.value.split(/\r\n|\r|\n/);
				if (newValue !== null && typeof newValue !== 'number') {
					this.idRegisterList = this.parseToNumber(
						this.idRegisterList
					);
				}
				e.target.value = this.idRegisterList.join('\n');
			},
			async add() {
				if (this.getNum < 1) {
					alert('푸시 발송 대상으로 추가할 회원항번을 입력해주세요.');
					return;
				}
				const idRegisters = this.idRegisterList;
				const params = {
					idRegisters,
					limit: 0,
					offset: 0,
				};
				try {
					const { data } = await this.$axiosAdmin2.post(
						'/api/noti/registers/search',
						params
					);
					const contentTotal = data.contentTotal;
					if (
						this.getNum !== contentTotal &&
						!confirm(
							`푸시 발송 대상 중 발송이 불가한 ${this.getNum - contentTotal}명을 제외한 나머지 ${contentTotal}명이 추가되었습니다.`
						)
					) {
						return;
					}
					this.$store.commit('PushController/addUserList', {
						userList: data.data,
						filter: params,
						count: contentTotal,
					});
					this.$store.commit('modal/toggleModal', false);
				} catch (err) {
					console.error(err);
					if (err.response && err.response.status === 452) {
						alert(err.response.data.message);
					} else {
						alert(
							'대상 추가가 불가능 합니다. 개발팀에 문의해주세요.'
						);
					}
				}
			},
			cancel() {
				this.$store.commit('modal/toggleModal', false);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.push-target-direct__desc {
		display: block;
		margin: 12px 0;
	}

	.push-target-direct__id-box {
		display: block;
		width: 100%;
		height: 276px;
		overflow-y: auto;
		resize: none;
		border-bottom-left-radius: 2px;
		border-bottom-right-radius: 2px;
		border: solid 1px #dfe6ee;
		line-height: 30px;
		color: #222;
		font-size: 1rem;
		font-weight: bold;
		padding: 13px 30px;
	}

	.push-target-direct__result {
		@extend .push-target-direct__desc;

		color: $red;
		font-weight: 700;
	}
</style>
